import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider, CircularProgress } from '@mui/material';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import App from './App';
import ApplicationTheme from './utilities/theme';
import reportWebVitals from './reportWebVitals';
import SnackbarAlert from './components/common/snackbar-alert';
import Loader from './components/common/loader';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<CircularProgress />} persistor={persistor}>
        <ThemeProvider theme={ApplicationTheme}>
          <CssBaseline />
          <App />
          <SnackbarAlert />
          <Loader />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
